import { AppState } from "../../../../redux-configuration/AppState";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { EcommerceOrderDetailsContainer } from "./orderDetails.container";
import { companySelector } from "../../../../company/usecases/updateStoreCompany/selector";
import { Company } from "../../../../company/domain/entity/company";
import { EcommerceOrder } from "../../../domain/entities/ecommerceOrder";
import {
    ecommerceOrdersSelector,
    loadEcommerceOrdersErrorSelector,
    loadEcommerceOrdersLoadingSelector,
} from "../../../usecases/loadOrders/selectors";
import { LoadEcommerceOrdersAction } from "../../../usecases/loadOrders/actionTypes";
import { loadEcommerceOrders } from "../../../usecases/loadOrders/actions";

interface StateToPropsType {
    orders: EcommerceOrder[] | undefined;
    company: Company | null;
    loading: boolean;
    error: string | undefined;
}

interface DispatchToPropsType {
    loadOrders: (companyId: string) => void;
}

const mapStateToProps = (state: AppState): StateToPropsType => ({
    company: companySelector(state),
    orders: ecommerceOrdersSelector(state),
    loading: loadEcommerceOrdersLoadingSelector(state),
    error: loadEcommerceOrdersErrorSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch): DispatchToPropsType => ({
    loadOrders: (companyId: string): LoadEcommerceOrdersAction =>
        dispatch(loadEcommerceOrders(companyId)),
});

export const EcommerceOrderDetailsPage = connect(
    mapStateToProps,
    mapDispatchToProps
)(EcommerceOrderDetailsContainer);
